class EnvelopeConnection {
    constructor(envelope, mode) {
        this.envelope = envelope;
        this.mode = mode;
    }

    equals(obj) {
        return this.envelope === obj.envelope &&
            this.mode === obj.mode;
    }

    getJson() {
        return {
            envelope: this.envelope.number - 1,
            mode: this.mode,
        };
    }
}

export default EnvelopeConnection;
